import { ErrorType, __DEV__ } from "./config";

/** 处理 Error 对堆栈信息返回为 msg */
const processStackMsg = (error) => {
  let stack =
    error.stack
      ?.replace(/\n/gi, "")
      .split(/\bat\b/)
      .slice(0, 9)
      .join("@")
      .replace(/\?[^:]+/gi, "") || "";
  const msg = error.toString();
  if (stack.indexOf(msg) < 0) {
    stack = msg + "@" + stack;
  }
  return stack;
};

/**
 * @description: 异常捕获
 * @return {*}
 */
export class ErrorCatch {
  static #_instance;
  id = Math.random();
  enable = true;
  callback = null;
  debug = false;

  static getInstance({ enable = true, callback = null, debug = false }) {
    if (!ErrorCatch.#_instance) {
      ErrorCatch.#_instance = new ErrorCatch({ enable, callback, debug });
    }
    return ErrorCatch.#_instance;
  }

  constructor({ enable = true, callback = null, debug = false }) {
    if (!ErrorCatch.#_instance) {
      this.id = Math.random();
      this.enable = enable;
      this.callback = callback;
      this.debug = debug;
      if (!this.enable) {
        console.warn("Monitor ErrorCatch is Disable!");
      }
    }
  }

  /**
   * @description: 捕获"暴露到全局错误"的钩子函数
   * @return {*}
   */
  windowErrorHandler() {
    if (!this.enable) return;

    window.onerror = (message, target, row, col, error) => {
      const msg = error && error.stack ? processStackMsg(error) : message;
      const data = {
        name: (error && error.name) || "uncatchErrorName",
        type: ErrorType.generalError,
        msg,
        target: target || "global",
        ext: JSON.stringify({ row, col }),
      };

      if (this.callback) this.callback(data);
      if (__DEV__ && this.debug) console.table(data);
    };
  }

  /**
   * @description: 提供接管 Vue 错误的钩子函数
   * @param {*} error
   * @param {*} vm
   * @param {*} info
   * @return {*}
   */
  vueErrorHandler(error, vm, info) {
    if (!this.enable) return;

    const msg =
      error && error.stack ? processStackMsg(error) : error.toString();

    const target =
      vm.$options.name ||
      vm.$options.componentName ||
      vm.$options._componentTag;

    const data = {
      name: error && error.name,
      type: ErrorType.vueCatchError,
      msg,
      target: `Component/Tag：${target}`,
      ext: JSON.stringify({
        info: `Error In ${info}`,
      }),
    };

    if (this.callback) this.callback(data);
    if (__DEV__ && this.debug) console.table(data);

    throw error; // 抛还给 Vue，这里抛出的错误不会造成重复记错
  }

  /**
   * @description: 提供在 try catch 进行错误捕获的钩子函数,，可以挂在 Vue.prototype 上
   * vm 支持用 vue 实例，也可以传一个字符串之类的
   * @param {*} error
   * @param {*} vm
   * @param {*} info
   * @return {*}
   */
  tryCatchHandler(error, vm, info) {
    if (!this.enable) return;

    const msg =
      error && error.stack ? processStackMsg(error) : error.toString();

    const target =
      vm && Object.prototype.hasOwnProperty.call(vm, "$options")
        ? `Component/Tag: ${
            vm.$options.name ||
            vm.$options.componentName ||
            vm.$options._componentTag
          }`
        : String(vm);

    const data = {
      name: error && error.name,
      type: ErrorType.tryCatchError,
      msg,
      target,
      ext: JSON.stringify({ info: `Error In ${info}` }),
    };

    if (this.callback) this.callback(data);
    if (__DEV__ && this.debug) console.table(data);
  }
}
